export const environment = {
  production: false,
  serviceWorker: true,
  nihs: {
    api_base_url: 'https://nihsdevapi.di11soft.com',
  },
  otp:{
    otp_base_url:'https://otp.di11soft.com',
  },
  version: '1.0.0',
};
